import { FormControl, InputLabel, MenuItem, OutlinedInput, Select, Tab, Tabs, Tooltip } from '@mui/material';
import { useState } from 'react';
import { connect } from 'react-redux';
import Earning from '../../Earning';
import { PerformanceContext } from './PerformanceContext';
import currency from 'currency.js';
import Payment from '../../Payment';
import MyFund from '../../MyFund';
import './style.scss';
import './style.darkmode.scss';

const PerformanceWidget = ({
    user
}) => {
    const [activeTab, setActiveTab] = useState('earnings');
    // const [period, setPeriod] = useState('1_MONTH');
    const [period, setPeriod] = useState('14_DAYS');
    const [total, setTotal] = useState(0);

    const [fundTotal, setFundTotal] = useState(0);
    const [viewType, setViewType] = useState('summary');
    const [subscriptionTotal, setSubscriptionTotal] = useState(0);
    const [tipsTotal, setTipsTotal] = useState(0);
    const [ppvTotal, setPpvTotal] = useState(0);
    const [referralTotal, setReferralTotal] = useState(0);
    const [chargebackTotal, setChargebackTotal] = useState(0);

    const handleChange = (e, value) => {
        setActiveTab(value);
    };

    const handlePeriodChange = (e) => {
        setPeriod(e.target.value);
    };

    return <div className='performance-widget'>
        <Tabs
            value={activeTab}
            onChange={handleChange}
            sx={{
                '& .Mui-selected': {
                    color: '#0097fe !important'
                }
            }}
            variant="fullWidth"
            centered
        >
            <Tab
                value="earnings"
                icon={<i className="fa-sharp fa-regular fa-coins"></i>}
            />
            <Tab
                icon={<i className="fa-solid fa-wallet"></i>}
                value="payments"
            />
            <Tab
                icon={<i className="fa-solid fa-hand-holding-circle-dollar"></i>}
                value="my-funds"
            />
        </Tabs>

        {/* Contents */}
        {
            activeTab === 'my-funds'
                ? <div className='my-funds'>
                    <div className='my-funds__header'>
                        <h6>My Funds</h6>
                    </div>
                    <div style={{
                        maxHeight: 'calc(100vh - 550px)',
                        overflow: 'auto'
                    }}>

                        <MyFund
                            setTotal={setFundTotal}
                            setSubscriptionTotal={setSubscriptionTotal}
                            subscriptionTotal={subscriptionTotal}
                            setTipsTotal={setTipsTotal}
                            tipsTotal={tipsTotal}
                            setPpvTotal={setPpvTotal}
                            ppvTotal={ppvTotal}
                            setReferralTotal={setReferralTotal}
                            referralTotal={referralTotal}
                            setChargebackTotal={setChargebackTotal}
                            chargebackTotal={chargebackTotal}
                            viewType={viewType}
                            fundTotal={fundTotal}
                        />
                    </div>
                </div>
                : null
        }

        {
            activeTab === 'payments'
                ? <div className='payments'>
                    <div className='payments__header'>
                        <h6>Payments</h6>
                    </div>
                    <div className='payments__options'>
                        <div>
                            Total for period {currency(total).format({ precision: 2 })}
                        </div>
                        <div>
                            <FormControl sx={{ m: 1, minWidth: 80 }}>
                                <InputLabel
                                    id="period"
                                >Select Period</InputLabel>
                                <Select
                                    value={period}
                                    size="small"
                                    onChange={handlePeriodChange}
                                    input={<OutlinedInput label="Select Period" size='small' />}
                                    labelId="period"
                                    id="payments-period-autowidth"
                                    autoWidth
                                >
                                    <MenuItem value="1_HR">1 Hour</MenuItem>
                                    <MenuItem value="24_HRS">24 Hours</MenuItem>
                                    <MenuItem value="7_DAYS">7 Days</MenuItem>
                                    {/* <MenuItem value="1_MONTH">1 Month</MenuItem> */}
                                    <MenuItem value="14_DAYS">14 Days</MenuItem>
                                    <MenuItem value="ALL_TIME">All Time</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <PerformanceContext.Provider value={{ period, setTotal }}>
                        <div style={{
                            maxHeight: 'calc(100vh - 550px)',
                            overflow: 'auto'
                        }}>
                            <Payment />
                        </div>
                    </PerformanceContext.Provider>
                </div>
                : null
        }

        {
            activeTab === 'earnings'
                ? <div className='earnings'>
                    <div className='earnings__header'>
                        <h6>Earnings</h6>
                    </div>
                    <div className='earnings__options'>
                        <div style={{ fontSize: '14px' }}>
                            <strong>Total for period {currency(total).format({ precision: 2 })}</strong>
                        </div>
                        <div>
                            <FormControl sx={{ m: 1, minWidth: 80 }}>
                                <InputLabel
                                    id="period"
                                >Select Period</InputLabel>
                                <Select
                                    value={period}
                                    size="small"
                                    onChange={handlePeriodChange}
                                    input={<OutlinedInput label="Select Period" size='small' />}
                                    labelId="period"
                                    id="earnings-period-autowidth"
                                    autoWidth
                                >
                                    <MenuItem value="1_HR">1 Hour</MenuItem>
                                    <MenuItem value="24_HRS">24 Hours</MenuItem>
                                    <MenuItem value="7_DAYS">7 Days</MenuItem>
                                    {/* <MenuItem value="1_MONTH">1 Month</MenuItem> */}
                                    <MenuItem value="14_DAYS">14 Days</MenuItem>
                                    <MenuItem value="ALL_TIME">All Time</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </div>

                    <PerformanceContext.Provider value={{ period, setTotal }}>
                        <div style={{
                            maxHeight: 'calc(100vh - 550px)',
                            overflow: 'auto'
                        }}>
                            <Earning />
                        </div>
                    </PerformanceContext.Provider>
                </div>
                : null
        }
    </div>;
};

const mapStateToProps = state => ({
    user: state.user
});

export default connect(mapStateToProps)(PerformanceWidget);